import React, { Component } from 'react'
import Slider from 'react-slick'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'

import './TeamRevenueMobile.sass'
import { formatNoDecimalBigInt, formatNoDecimal, formatDecimal } from '@atheneum/api/dist/lib'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import PropTypes from 'prop-types'

class TeamRevenueMobile extends Component {
  static propTypes = {
    teamMembers: PropTypes.array,
    totals: PropTypes.object,
    activeSubTeamNumber: PropTypes.number,
    subTeamActive: PropTypes.bool
  }

  constructor (props) {
    super(props)
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
    this.calculateNextPrevious = this.calculateNextPrevious.bind(this)

    this.state = {
      canGoNext: true,
      canGoPrevious: false
    }
  }

  calculateNextPrevious (slide) {
    this.setState({
      canGoNext: !(
        slide >=
        this.props.teamMembers.length + 1 - this.slider.props.slidesToShow
      ),
      canGoPrevious: !(slide <= 0)
    })
  }

  next () {
    this.slider.slickNext()
  }

  previous () {
    this.slider.slickPrev()
  }

  render () {
    const settings = {
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1.2,
      slidesToScroll: 1,
      afterChange: this.calculateNextPrevious
    }

    return (
      <div className='mobile-teamRevenue-slider-container'>
        <div className='mobile-teamRevenue-labels'>
          <div className='teamRevenue-table-cell-mobile'>Name</div>
          <div className='teamRevenue-table-cell-mobile'>Position</div>
          <div className='teamRevenue-table-cell-mobile'>Deliveries</div>
          <div className='teamRevenue-table-cell-mobile'>Interviews</div>
          <div className='teamRevenue-table-cell-mobile'>Revenue €</div>
          <div className='teamRevenue-table-cell-mobile'>Costs €</div>
          <div className='teamRevenue-table-cell-mobile'>Gross Margin €</div>
          <div className='teamRevenue-table-cell-mobile'>Target €</div>
          <div className='teamRevenue-table-cell-mobile'>Achievement %</div>
        </div>
        <div className='mobile-teamRevenue-slider'>
          <Slider ref={c => (this.slider = c)} {...settings}>
            <div className='mobile-teamRevenue-slide'>
              <div className='teamRevenue-table-cell-mobile'>Team Overall</div>
              <div className='teamRevenue-table-cell-mobile'>-</div>
              <div className='teamRevenue-table-cell-mobile'>
                {this.props.totals.employeeDeliveries ?? '-'}
              </div>
              <div className='teamRevenue-table-cell-mobile'>
                {this.props.totals.interviewCount ?? '-'}
              </div>
              <div className='teamRevenue-table-cell-mobile'>
                {formatNoDecimalBigInt(this.props.totals.revenue)}
              </div>
              <div className='teamRevenue-table-cell-mobile'>
                {formatNoDecimalBigInt(this.props.totals.cost)}
              </div>
              <div className='teamRevenue-table-cell-mobile'>
                {formatNoDecimal(this.props.totals.grossMargin)}
              </div>
              <div className='teamRevenue-table-cell-mobile'>
                {formatNoDecimal(this.props.totals.targetMargin)}
              </div>
              <div className='teamRevenue-table-cell-mobile'>
                {formatDecimal(this.props.totals.achievement)}
              </div>
            </div>
            {this.props.teamMembers.map((teamMember, index) => (
              <div className='mobile-teamRevenue-slide' key={index}>
                <div
                  data-title={teamMember.fullName ?? '-'}
                  className='teamRevenue-table-cell-mobile teamRevenue-table-cell-mobile__name'
                >
                  {teamMember.fullName ?? '-'}
                </div>
                <div className='teamRevenue-table-cell-mobile'>
                  {teamMember.position ?? '-'}
                </div>
                <div className='teamRevenue-table-cell-mobile'>
                  {teamMember.employeeDeliveries ?? '-'}
                </div>
                <div className='teamRevenue-table-cell-mobile'>
                  {teamMember.interviewCount ?? '-'}
                </div>
                <div className='teamRevenue-table-cell-mobile'>
                  {formatNoDecimalBigInt(teamMember.revenue)}
                </div>
                <div className='teamRevenue-table-cell-mobile'>
                  {formatNoDecimalBigInt(teamMember.cost)}
                </div>
                <div className='teamRevenue-table-cell-mobile'>
                  {formatNoDecimal(teamMember.grossMargin)}
                </div>
                <div className='teamRevenue-table-cell-mobile'>
                  {formatNoDecimal(teamMember.targetMargin)}
                </div>
                <div className='teamRevenue-table-cell-mobile'>
                  {formatDecimal(teamMember.targetMargin)}
                </div>
              </div>
            ))}
          </Slider>
          <div className='slider-chevrons'>
            <button
              disabled={!this.state.canGoPrevious}
              onClick={this.previous}
            >
              <ChevronLeftIcon />
            </button>
            <button disabled={!this.state.canGoNext} onClick={this.next}>
              <ChevronRightIcon />
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default TeamRevenueMobile
